import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { RemoveDataModalComponent } from '../../entry-components/remove-data-modal/remove-data-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html'
})
export class UserListComponent {
    @Input() users: [];
    @Output()
    eventBus: EventEmitter<any> = new EventEmitter<any>();
    values: any;
    teamId: string;

    constructor(    
        private modalService: NgbModal, 
        private router: Router,
    ) {}

    onClickRemoveUser(user) {
        const modalRef = this.modalService.open(RemoveDataModalComponent, { size: 'lg' });
        modalRef.result.then(
            () => {
                this.removeUser(user.id);
            },
            reason => {}
        );
        modalRef.componentInstance.record = [
            { key: 'First Name', value: user.first_name },
            { key: 'Last Name', value: user.last_name },
            { key: 'Email', value: user.email }
        ];
        modalRef.componentInstance.headerTitle = 'Remove user';
        modalRef.componentInstance.bodyText = 'Are you sure you want to remove this user?';
    }

    isAdmin(user) {
        let value = false
        user.roles.forEach(element => {
            if (element.title == 'Admin') {
                value = true
            } });
        return value
    }

    isReviewer(user) {
        let value = false
        user.roles.forEach(element => {
            if (element.title == 'Review board') {
                value = true
            } });
        return value
    }

    getRoles(user) {
        let roleList = []
        user.roles.forEach(element => {
            if (roleList.findIndex(role => role.title == element.title) < 0) {
                roleList.push(element)
            }         
        });
        return roleList
    }

    isStatistics(user) {
        let value = false
        user.roles.forEach(element => {
            if (element.title == 'Statistics') {
                value = true
            } });
        return value
    }

    manageUser(user, event) {
        switch (event.target.value) {
            case 'setAdmin': this.setAdmin(user.id);
            break;
            case 'setStatistics': this.setStatistics(user.id);
            break;
            case 'onClickRemoveUser': this.onClickRemoveUser(user);
            break;
            case 'removeStatistics': this.removeStatistics(user.id);
            break;
            case 'setReviewer': this.setReviewer(user.id);
            break;
            case 'editUserDetails': this.editUserDetails(user.id);
            break;
            case 'removeReviewer': this.removeReviewer(user.id);
            break;
    }
}

    removeUser(userId) {
        const event = {
            action: 'removeUser',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    editUserDetails(userId) {
        this.router.navigate(['/team', userId]);
    }

    setAdmin (userId) {
        const event = {
            action: 'setAdmin',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    setStatistics (userId) {
        const event = {
            action: 'setStatistics',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    removeStatistics(userId) {
        const event = {
            action: 'removeStatistics',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    setReviewer(userId) {
        const event = {
            action: 'setReviewer',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    removeReviewer(userId) {
        const event = {
            action: 'removeReviewer',
            payload: {
                userId
            }
        };
        this.eventBus.emit(event);
    }

    trackByFn = (index, item) => item.id || index;
}
